import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getUsersById } from 'auth/store/users/selectors';
import Flex from 'base/components/Flex';
import CustomScroll from 'base/components/ScrollBar';
import Loader from 'base/components/Loader';
import FileExplorerTeaser
  from 'dashboard/containers/FileExplorerTeaser/FileExplorerTeaser';
import FileExplorerTeaserSkeleton
  from 'dashboard/containers/FileExplorerTeaser/FileExplorerTeaserSkeleton';
import { fetchFeed } from '../../store/actions';
import { getFeedIsLoading, getFeed } from '../../store/selectors';

const WidgetWrapper = styled(Flex)`
  position: relative;
  flex-direction: column;
  height: 100%;
`;


class Feed extends React.Component {
  componentDidMount() {
    this.props.fetchFeed(this.props.spaceId);
  }


  render() {
    const {
      items, users, spaceId, isLoading,
    } = this.props;

    return (
      <WidgetWrapper>
        <CustomScroll>
          <Loader isLoading={isLoading} fallback={<FileExplorerTeaserSkeleton />}>
            {items && items.map((item) => (
              <FileExplorerTeaser
                key={item.id}
                entity={item}
                users={users}
                spaceId={spaceId}
              />
            ))}
          </Loader>
        </CustomScroll>
      </WidgetWrapper>
    );
  }
}
Feed.propTypes = {
  users: PropTypes.objectOf(PropTypes.any).isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  fetchFeed: PropTypes.func.isRequired,  // eslint-disable-line
  spaceId: PropTypes.number, // eslint-disable-line
  isLoading: PropTypes.bool.isRequired, // eslint-disable-line
};
Feed.defaultProps = {
  spaceId: null,
};

const mapStateToProps = (state, props) => ({
  items: getFeed(state, props),
  isLoading: getFeedIsLoading(state, props),
  users: getUsersById(state),
});
const mapDispatchToProps = {
  fetchFeed,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Feed);
